'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _reactRouter = require('react-router');

var _resources = require('redux/modules/resources');

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

var _modules = require('redux/modules/modules');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module1App6 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    profile: state.profile.data,
    allModule: state.moduleData.data.module1,
    app: state.moduleData.data.module1.app6,
    module: state.resources.module,
    item: state.resources.item
  };
}, (0, _extends3.default)({}, moduleActions, { changeResource: _resources.changeResource, changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module1App6, _Component);

  function Module1App6() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module1App6);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module1App6.__proto__ || (0, _getPrototypeOf2.default)(Module1App6)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 1,
      appId: 9,
      isCompleted: _this.props.app.isCompleted || false,
      title: 'General serve guide'
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }

      obj.isCompleted = true;
      _this.setState(obj);

      // update the actual app
      // this.props.updateModuleApp(this.props.user.userId, this.state.moduleId, this.state.appId, this.state);
      _this.props.updateModuleApp(_this.props.user.userId, 1, 6, _this.state);

      // update the overarching module's details
      _this.props.updateModule(_this.props.user.userId, _this.state.moduleId, {
        'numAppCompleted': numAppCompleted,
        'numAppTotal': _this.props.allModule.numAppTotal });

      _this.props.changeItem(_this.state.moduleId, 0, _this.state.appId + 1);
    }, _this.convertISOTimeToAge = function () {
      var now = new Date();
      var date = new Date(_this.props.profile.childDOB);
      var yearDiff = now.getFullYear() - date.getFullYear();
      var monthDiff = now.getMonth() - date.getMonth();
      var dayDiff = now.getDay() - date.getDay();

      if (monthDiff < 0) {
        yearDiff--;
      } else if (monthDiff === 0) {
        if (dayDiff < 0) {
          yearDiff--;
        }
      }
      return yearDiff;
    }, _this.handleResourceClick = function (module, item, event) {
      console.log(event);
      _this.props.changeResource(module, item);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * Handle when user finishes this module
   */


  // used to navigate to a resource item


  (0, _createClass3.default)(Module1App6, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');
      var generalServeGuideImg = require('../Assets/generalserveguide.png');
      var fouryearold = require('../Assets/4to8.png');
      var nineyearold = require('../Assets/9to13.png');

      var age = this.convertISOTimeToAge();

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 1'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            'p',
            { className: styles.orangeText },
            'This is what your child\'s meal could look like to partly meet their serves for the day'
          ),
          _react2.default.createElement(
            'p',
            null,
            'This is a general guide about serves for your child\'s age group. Differences exist between children in this age group for reasons such as height, activity level and gender, as examples.'
          ),
          _react2.default.createElement('div', { className: styles.spacer40 }),
          age <= 3 && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 7 },
              _react2.default.createElement(ReactBootstrap.Image, { src: generalServeGuideImg, responsive: true })
            ),
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 5 },
              _react2.default.createElement(
                'h4',
                { className: styles.orangeText },
                '2 - 3 years old'
              ),
              _react2.default.createElement(
                ReactBootstrap.Table,
                { striped: true, bordered: true, responsive: true },
                _react2.default.createElement(
                  'thead',
                  null,
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'th',
                      null,
                      'Core food group'
                    ),
                    _react2.default.createElement(
                      'th',
                      null,
                      '% requirements met'
                    )
                  )
                ),
                _react2.default.createElement(
                  'tbody',
                  null,
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'td',
                      null,
                      'Vegetables'
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      '60%'
                    )
                  ),
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'td',
                      null,
                      'Meat and alternatives'
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      '75%'
                    )
                  ),
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'td',
                      null,
                      'Grains and cereals'
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      '15%'
                    )
                  ),
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'td',
                      null,
                      'Dairy and alternatives'
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      '30%'
                    )
                  ),
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'td',
                      null,
                      'Fruit'
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      '50%'
                    )
                  )
                )
              )
            )
          ),
          age >= 4 && age <= 8 && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 7 },
              _react2.default.createElement(ReactBootstrap.Image, { src: fouryearold, responsive: true })
            ),
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 5 },
              _react2.default.createElement(
                'h4',
                { className: styles.orangeText },
                '4 - 8 years old'
              ),
              _react2.default.createElement(
                ReactBootstrap.Table,
                { striped: true, bordered: true, responsive: true },
                _react2.default.createElement(
                  'thead',
                  null,
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'th',
                      null,
                      'Core food group'
                    ),
                    _react2.default.createElement(
                      'th',
                      null,
                      '% requirements met'
                    )
                  )
                ),
                _react2.default.createElement(
                  'tbody',
                  null,
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'td',
                      null,
                      'Vegetables'
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      '60%'
                    )
                  ),
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'td',
                      null,
                      'Meat and alternatives'
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      '75%'
                    )
                  ),
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'td',
                      null,
                      'Grains and cereals'
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      '25%'
                    )
                  ),
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'td',
                      null,
                      'Dairy and alternatives'
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      '30%'
                    )
                  ),
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'td',
                      null,
                      'Fruit'
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      '60%'
                    )
                  )
                )
              )
            )
          ),
          age >= 9 && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 7 },
              _react2.default.createElement(ReactBootstrap.Image, { src: nineyearold, responsive: true })
            ),
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 5 },
              _react2.default.createElement(
                'h4',
                { className: styles.orangeText },
                '9 - 13 years old'
              ),
              _react2.default.createElement(
                ReactBootstrap.Table,
                { striped: true, bordered: true, responsive: true },
                _react2.default.createElement(
                  'thead',
                  null,
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'th',
                      null,
                      'Core food group'
                    ),
                    _react2.default.createElement(
                      'th',
                      null,
                      '% requirements met'
                    )
                  )
                ),
                _react2.default.createElement(
                  'tbody',
                  null,
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'td',
                      null,
                      'Vegetables'
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      '60%'
                    )
                  ),
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'td',
                      null,
                      'Meat and alternatives'
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      '75%'
                    )
                  ),
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'td',
                      null,
                      'Grains and cereals'
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      '20%'
                    )
                  ),
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'td',
                      null,
                      'Dairy and alternatives'
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      '30%'
                    )
                  ),
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'td',
                      null,
                      'Fruit'
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      '50%'
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/resourceslanding', onClick: this.handleResourceClick.bind(this, 1, 0) },
              'Click here '
            ),
            'to see how the same meal could be adapted to suit the requirements for children of different ages!'
          ),
          _react2.default.createElement(
            ReactBootstrap.Col,
            { md: 12 },
            _react2.default.createElement('div', { className: styles.spacer20 }),
            _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete }),
            _react2.default.createElement('div', { className: styles.spacer100 })
          )
        )
      );
    }
  }]);
  return Module1App6;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  profile: _propTypes2.default.object,
  allModule: _propTypes2.default.object,
  app: _propTypes2.default.object,
  updateModule: _propTypes2.default.func,
  updateModuleApp: _propTypes2.default.func,
  module: _propTypes2.default.number,
  item: _propTypes2.default.number,
  changeResource: _propTypes2.default.func.isRequired,
  changeItem: _propTypes2.default.func
}, _temp2)) || _class);
exports.default = Module1App6;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/1/App/App6.js
// module id = 1169
// module chunks = 0